export default "__VITE_ASSET__c39Ca1XY__"